//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import colors from "~/assets/theme/colors";
import PopOver from "../../form/PopOver.vue";
import { plugins, scales } from "./config";

import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  Filler,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
    PopOver,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    elements: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: "h-88",
    },
  },
  data() {
    return {
      range: this.options[0],
      currentLocale: null,
    };
  },
  computed: {
    hasDatasets() {
      return this.elements?.datasets?.length > 0;
    },
    config() {
      return {
        chartData: {
          labels: this.elements.labels.map((el) => this.$d(new Date(el * 1000), "simple")),
          datasets: [
            {
              backgroundColor: colors.primary.light,
              fill: true,
              borderWidth: 1,
              data: this.elements.datasets[0].data.map((el) => el),
              tension: 0,
            },
          ],
        },
        chartOptions: {
          maintainAspectRatio: false,
          responsive: true,
          plugins,
          scales,
        },
      };
    },
  },
  created() {
    this.currentLocale = this.$i18n.locale;
  },
  methods: {
    onHasChanged() {
      this.$emit("hasChanged", this.range.value);
    },
  },
};
